let faqselector = $("#user-help-faq");

handleFaq();
displayFaq(faqselector.val());
handleFaqJumps();

faqselector.change(function () {
  displayFaq($(this).val());
});

if (typeof lead !== "undefined") {
  $comparisoncontrllist = $(".comparison__contrllist");
  $comparisoncontrl = $(".comparison__contrl");
  $comparisonitemlist = $(".comparison__itemlist");
  $comparisonitem = $(".comparison__item");
  showComparison($comparisonitemlist.data("current-comparison"));
  $(window).resize(function () {
    showComparison($comparisonitemlist.data("current-comparison"));
  });
  $comparisoncontrl.click(function () {
    let cc = $(this).data("comparison");
    $comparisonitemlist.data("current-comparison", cc);
    showComparison(cc);
  });
  $comparisonitemlist
    .touch({
      trackDocument: true,
      trackDocumentNormalize: true,
      preventDefault: {
        swipeLeft: true,
        swipeRight: true
      }
    })
    .on("swipeLeft", function (e, o) {
      showComparison("api");
    })
    .on("swipeRight", function (e, o) {
      showComparison("ftp");
    });
}

function displayFaq(issue) {
  // $.ajax({
  //     url: "/account-help-faq-content",
  //     method: "POST",
  //     data: {issue: issue},
  //     timeout: 20000,
  // })
  //     .done(function(response) {
  //         $('#faq-box').html(response.snippet);
  //         handleFaq();
  //     } , "json")
  //     .fail(function(error) {
  //         console.error(error);
  //     });
}

function handleFaq() {
  let faq_listitem_question = $(".faq__listitem_question");
  faq_listitem_question.click(function () {
    let parent = $(this).parent();
    let faq_id = $(this).data("faq-id");
    let open = parent.hasClass("faq__listitem faq__listitem--visibel");
    $(".faq__listitem_question-icon").removeClass(
      "faq__listitem_question-icon--open"
    );
    $(".faq__listitem").removeClass("faq__listitem--visibel");
    $(".faq__listitem_answer").removeClass("faq__listitem_answer--visibel");
    $(".faq__listitem_question-header").removeClass(
      "faq__listitem_question-header--visibel"
    );
    if (!open) {
      parent
        .find(".faq__listitem_question-icon")
        .addClass("faq__listitem_question-icon--open");
      $("#faq-item-" + faq_id).addClass("faq__listitem--visibel");
      $("#faq-answer-" + faq_id).addClass("faq__listitem_answer--visibel");
      $("#faq-question-" + faq_id).addClass(
        "faq__listitem_question-header--visibel"
      );
    }
  });
}

function handleFaqJumps() {
  let faq_jumpbutton_question = $(".faq__listitem_answer .faq_jump");

  faq_jumpbutton_question.click(function (event) {
    event.preventDefault();

    let target_id = "#faq-item-" + $(this).attr("target");
    let scroll_to_position = $(target_id).offset().top;

    $(target_id)[0].scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center"
    });

    $(target_id + " .faq__listitem_question").trigger("click");
  });
}

function showComparison(currentComparison) {
  $comparisonitemlist.css("left", 0);
  let i;
  if ($(window).width() < 640) {
    let comparisonitems = $(".comparison__item");
    let windowwidth = $(window).width();
    let itemwidth = comparisonitems.outerWidth();
    let positionleft = $comparisonitemlist.position().left;
    let offset = 0;
    if (currentComparison === "api") {
      offset = -itemwidth;
    }
    offset = offset + ((windowwidth - itemwidth) / 2 - positionleft);
    $comparisonitemlist.css("left", offset);
    for (i = 0; i < $comparisoncontrl.length; i++) {
      $($comparisoncontrl[i]).removeClass("comparison__contrl--active");
      if ($($comparisoncontrl[i]).data("comparison") === currentComparison) {
        $($comparisoncontrl[i]).addClass("comparison__contrl--active");
      }
    }
    for (i = 0; i < $comparisonitem.length; i++) {
      $($comparisonitem[i]).removeClass("comparison__item--active");
      if (
        $($comparisonitem[i]).hasClass("comparison__item--" + currentComparison)
      ) {
        $($comparisonitem[i]).addClass("comparison__item--active");
      }
    }
  } else {
    for (i = 0; i < $comparisonitem.length; i++) {
      $($comparisonitem[i]).removeClass("comparison__item--active");
    }
  }
}
